






































import { Component, Prop, Vue } from "vue-property-decorator";
import { PhotoViewModel } from "./types";
import { Action, Getter } from "vuex-class";
import { PhotoTag } from "@/shared/models/photoTag";

@Component
export default class PhotoTile extends Vue {
  @Prop() endpoint?: string;
  @Prop() photo?: PhotoViewModel;

  @Action("codebooks/refreshPhotoTags") refreshTags?: () => Promise<void>;
  @Getter("codebooks/photoTags") tags?: PhotoTag[];

  src: any = "";
  mounted() {
    if (!this.photo?.id) {
      return;
    }

    Vue.axios
      .get(this.endpoint + "/" + this.photo?.id + "?width=280&quality=95", {
        responseType: "blob",
      })
      .then((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = () => {
          this.src = reader.result;
        };
      })
      .catch(() => {
        this.src = require("@/assets/images/no-image-icon-23488.png");
      });
  }

  async created() {
    if ((this.tags?.length ?? 0) === 0 && this.refreshTags) {
      await this.refreshTags();
    }
  }

  editPhoto() {
    this.$emit("edit", this.photo);
  }

  deletePhoto() {
    this.$emit("delete", this.photo);
  }

  get getTags() {
    return this.photo?.tagIds.slice(0, 3);
  }

  getTagText(id: number) {
    const tag = this.tags?.find((x) => x.id == id);
    if (!tag) {
      return "";
    }

    return this.$t(tag.textResourceKey);
  }
}
